/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdzentrale10Inputs */

const en__field_enum_sdzentrale10 = /** @type {(inputs: _Field_Enum_Sdzentrale10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zentrale Einrichtungen GU`)
};

const de__field_enum_sdzentrale10 = /** @type {(inputs: _Field_Enum_Sdzentrale10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zentrale Einrichtungen GU`)
};

/**
* | output |
* | --- |
* | "Zentrale Einrichtungen GU" |
*
* @param {_Field_Enum_Sdzentrale10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdzentrale10 = /** @type {((inputs?: _Field_Enum_Sdzentrale10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdzentrale10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdzentrale10(inputs)
	return de__field_enum_sdzentrale10(inputs)
});
export { _field_enum_sdzentrale10 as "_field_enum_SDZENTRALE" }